module.exports = __webpack_public_path__ + "img/group-2.f4dfe936.svg";